export default __webpack_public_path__ + "assets/empty_notifications.5bc8c8c2.svg";